<template>
  <div class="echart-box">
    <v-chart
      :options="option"
      ref="my"
      autoresize
    />
  </div>
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/component/legend";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/polar";
import "zrender/lib/svg/svg";
export default {
  name: "char1",
  components: {
    "v-chart": ECharts
  },
  props: {
    data: Object,
    datelist: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      option: {},
      viewdata: {},
      viewdate: [],
      timer:false
    };
  },
  watch: {
    datelist: {
      handler() {
        
        this.dataInit();
        this.init();
      },
      deep: false
    }
  },
  methods: {
    dataInit() {      
      this.viewdata.data1 = this.data.data1.slice(0, 5);
      this.viewdata.data2 = this.data.data2.slice(0, 5);     
      this.viewdate = this.datelist.slice(0, 5);     
      this.doit();
    },
    //滚动动画
    doit() {
      if(this.timer){
         clearTimeout(this.timer)
      }
     this.timer=setTimeout(() => {
        this.runData();
      }, 3000);
    },
    //滚动展示数据计算
    runData() {
      this.data.data1.push(this.data.data1.shift());
      this.data.data2.push(this.data.data2.shift());
      this.datelist.push(this.datelist.shift());
    },
    init() {
      this.option = {
        grid: {
          top: "10%",
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true
        },
        legend: {
          bottom: "2%",
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            color: "#fff"
          },
          icon: "rect",
          data: ["入库", "出库"]
        },
        tooltip: {
          formatter: function(params, index) {
            var result = params[0].name + "</br>";
            params.forEach(function(item) {
              if (item.seriesId == "a1") {
                result += item.seriesName + ":" + item.data + "</br>";
              } else if (item.seriesId == "a2") {
                //活跃会员数
                result += item.seriesName + ":" + item.data + "%</br>";
              } else if (item.seriesId == "a3") {
                //活跃会员数
                result += item.seriesName + ":" + item.data + "%</br>";
              } else {
                result += item.seriesName + ":" + item.data + "</br>";
              }
            });
            return result;
          },
          textStyle: {
            fontSize: 18
          },
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "#377DFF"
            }
          }
        },
        xAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: "#323645",
              type: "solid",
              width: 1
            },
            minInterval: 0
          },
          axisLabel: {
            color: "#fff"
          },
          data: this.viewdate,
          type: "category"
        },

        series: [
          {
            name: "入库",
            type: "line",
            itemStyle: {
              normal: {
                color: "#16CEB9"
                // barWidth:10
              }
            },
            data: this.viewdata.data1
          },
          {
            name: "出库",
            type: "line",
            itemStyle: {
              normal: {
                color: "#377DFF"
              }
            },
            data: this.viewdata.data2
          }
        ],

        yAxis: {
          axisLabel: {
            color: "#fff"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#323645",
              type: "dashed",
              width: 1
            },
            minInterval: 0
          },

          type: "value"
        }
      };
      setTimeout(()=>{
                  this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 1                     
                    })
                this.$nextTick(()=>{
                    this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 2                     
                    })
                })
            },500)   
    }
  },
  mounted() {
    // this.init();
  }
};
</script>